import { Tabs, styled } from '@mui/material';

const prefix = 'HusaFormPanel';
const classes = {
  root: `${prefix}-root`,
  tabIndicator: `${prefix}-tabIndicator`,
  tabLabel: `${prefix}-tabLabel`
};
const TabsStyled = styled(Tabs)(({ theme }) => ({
  [`&.${classes.root}`]: {
    backgroundColor: theme.palette.grey[200],
    borderTopColor: theme.palette.grey[200],
    borderTopWidth: 1,
    borderTopStyle: 'solid'
  },
  [`& .${classes.tabIndicator}`]: {
    display: 'none'
  },
  [`& .${classes.tabLabel}`]: {
    textTransform: 'none',
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      color: '#fff'
    }
  }
}));

export { TabsStyled, classes };
